import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc2009',
    ecrans: ['00-2'],
    params: ['id']
});
